import { Injector } from '@angular/core';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  currencyFormatInputFieldParseIntoSettingsFormModel,
  currencyFormatInputFieldUpdateFromSettingsFormModel,
} from '../custom-currency-format-field-type.configuration';

export class CurrencyFormatInputFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);
  }

  override parseFieldConfigIntoSettingsFormModel() {
    return currencyFormatInputFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return currencyFormatInputFieldUpdateFromSettingsFormModel(
      model,
      this.field
    );
  }
}
